import { render, staticRenderFns } from "./secondStep.vue?vue&type=template&id=3972f85d"
import script from "./secondStep.vue?vue&type=script&lang=js"
export * from "./secondStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports